// client/src/components/admin/tools/ConfirmActionButton.js
// Reusable button component with confirmation step for destructive actions
import { useState } from 'react'
import PropTypes from 'prop-types'
import ActionButton from './ActionButton'

/**
 * Button component with built-in confirmation step
 * @param {object} props - Component props
 * @param {string} props.label - Initial button label
 * @param {string} props.confirmLabel - Confirmation button label
 * @param {function} props.onConfirm - Callback when confirmed
 * @param {boolean} props.loading - Loading state
 * @param {string} props.variant - Button variant (default: 'danger')
 */
function ConfirmActionButton({
  label,
  confirmLabel,
  onConfirm,
  loading,
  variant = 'danger',
}) {
  const [confirming, setConfirming] = useState(false)

  if (!confirming) {
    return (
      <ActionButton
        label={label}
        onClick={() => setConfirming(true)}
        loading={loading}
        variant={variant}
      />
    )
  }

  const handleConfirm = async () => {
    await onConfirm()
    setConfirming(false)
  }

  return (
    <>
      <ActionButton
        label={confirmLabel}
        onClick={handleConfirm}
        variant={variant}
        loading={loading}
      />
      <ActionButton
        label="Cancel"
        onClick={() => setConfirming(false)}
        variant="secondary"
      />
    </>
  )
}

ConfirmActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  variant: PropTypes.string,
}

export default ConfirmActionButton
